import BaseService from "./BaseService";

export default class BankPartnerServices extends BaseService {
    public static getAllBankPartners(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'plaid/plaid-bank-list', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static createBankPartner(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'plaid/plaid-bank', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateBankPartner(token: string, fintechBankingPartnerId: any, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}plaid/plaid-bank/${fintechBankingPartnerId}`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            })
    }

    public static deleteBankPartner(token: string, fintechBankingPartnerId: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}plaid/plaid-bank/${fintechBankingPartnerId}`,
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
    }
}